const translations = {
    acres: 'acres',
    activity: 'Activity',
    adjustedBoundaryNameTemplate: '{{name}} (adjusted {{date}})',
    advancedSpraySettingsTitle: 'Advanced · Spray Settings',
    advancedTitle: 'Advanced',
    back: 'Back to Application',
    boundaryEditAddObstacle: 'Add obstacle',
    boundaryEditDeleteObstacle: 'Delete obstacle',
    boundaryEditDiscard: 'Discard',
    boundaryEditDone: 'Done editing',
    boundaryEditMoveVertices: 'Move vertices',
    boundaryEditToolbarLabel: 'Edit boundary',
    boundaryModifiedBadge: 'Modified',
    connecting: 'Preparing flight plan...',
    cornerFillHint: 'Adds fill passes in field corners.',
    coverageArea: 'Coverage Area',
    coverageOptionsTitle: 'Coverage Options',
    createFlightPlan: 'Create Flight Plan',
    discard: 'Discard',
    editApplication: 'Edit Application',
    editBoundaryEntry: 'Edit Boundary',
    editFlightPlan: 'Edit Flight Plan',
    exportToJohnDeere: 'Export to John Deere',
    flightTime: 'Flight Time',
    gallons: 'gallons',
    homePointCancelPickButton: 'Cancel',
    homePointLabel: 'Home Point',
    homePointMarkerAriaLabel: 'Home Point',
    homePointPickButton: 'Pick home point on map',
    homePointPickHint: 'Click the map to set the home point. Press ESC to cancel.',
    lastReplanTemplate: 'Last replan · {{ms}}ms',
    linkedEntities: 'Linked Entities',
    loadError: 'Failed to load application',
    mapComingSoon: 'Map view',
    pageTitle: 'Flight Planner',
    passOverlap: 'Pass Overlap',
    passes: 'Passes',
    pathAngleHint: 'Pick the path angle that minimizes turns.',
    placeholderValue: '—',
    primaryParamsEyebrowSubtitle: 'Flight Plan',
    primaryParamsEyebrowTitle: 'Primary Parameters',
    productive: 'Productive',
    replanningLabel: 'Replanning…',
    save: 'Save',
    saveError: 'Failed to save flight plan',
    sendToDrone: 'Send to Drone',
    sendToDroneFailed: 'Send to drone failed: {{error}}',
    sendToDroneNoSession: 'Send to drone unavailable — planner session not ready.',
    sendToDroneResult: '{{waypointCount}} waypoints · {{flightSeconds}}s · {{tankUsed}} L used',
    sendToDroneSending: 'Sending to drone…',
    spraySettingsTitle: 'Spray Settings',
    totalDistance: 'Total Distance',
    turns: 'Turns'
};

export default translations;
